export default "/_next/static/images/philips-1133205c3a338a831d42fa8a428919d3.svg";